import React, { Component, Suspense } from 'react';
import _ from 'lodash';
import NoSSR from 'react-no-ssr';
import Head from 'next/head';

import { Divider, Container, Grid, Segment, Header, Image, Table, Loader, Message, Button, Label, Tab, GridColumn, List, Modal, Icon } from 'semantic-ui-react';
import { i18n, withNamespaces, Link, Router } from '../i18n';
import Text, { TextParser } from '../components/Text';
import { GET_APIS_URL, GET_END_POINTS_URL, STRINGS, PRICE_PER_CALL } from '../constants/constants';
import { ssrFetch, rest } from '../lib/rest';
import dynamic from 'next/dynamic';
import ReactHtmlParser from 'react-html-parser';
import { useRouter } from 'next/router';
const Swagger = React.lazy(() => import('../components/Swagger'));

const Accordion = dynamic(() => import('../components/api_accordion'), {
	loading: () => <Loader active inline="centered" content="Loading..." />,
	ssr: false,
});

/**
 * alternatif yazım şekli
 * <Text>
				{parser => (
					<Head>
						<title>CollectApi - {parser(api.name)}</title>
						<description>{parser(api.description)}</description>
					</Head>
				)}
			</Text>
 */

const Description = ({ api, t, scopes, i18n, isSubs, apiPackage }) => {
	if (!api) return;
	return (
		<React.Fragment>
			<Text
				render={parser => (
					<Head>
						<title key="title">CollectAPI - {parser(api.page_title || api.name)}</title>
						<meta name="description" key="description" content={parser(api.description)} />
					</Head>
				)}
			/>
			<p>
				<div style={{ textAlign: 'left', padding: '10px' }}>
					{api.newDescription && api.newDescription[i18n.language] ? ReactHtmlParser(api.newDescription[i18n.language]) : ReactHtmlParser(api.description[i18n.language])}
				</div>
				{api.group_id === 'whatsapp' ? (
					<p>
						<a href="https://yapaytech.com/products/whatsapp-business-api/documentations">https://yapaytech.com/products/whatsapp-business-api/documentations</a>
					</p>
				) : (
					''
				)}
			</p>
			{apiPackage && apiPackage.country ? (
				<p>
					{t('supportedCountry')}: {_.map(apiPackage.country[i18n.language]).join(', ')}
				</p>
			) : (
				''
			)}

			{!isSubs && api.free ? (
				<div style={{ marginTop: '10px' }}>
					<p style={{ marginBottom: '10px' }}>{t('haveFreePack')}</p>
					<Link href={'/api/id_' + api._id + '?tab=pricing'}>
						<Button primary size="mini">
							{t('freeTry')}
						</Button>
					</Link>
				</div>
			) : (
				''
			)}
		</React.Fragment>
	);
};

class PricingTab extends React.PureComponent {
	state = { loading: true, freeButtonLoad: false, messageOnScreen: '', messageColor: '', openModal: false, warningModal: false, cancelModal: false };

	componentDidMount() {
		this.loadPricing();
	}

	freeSubs = (api, limit) => async ({ req, res }) => {
		if (!!this.props.session.user) {
			this.setState({ freeButtonLoad: true });
			rest('/rest/subscription/freeCreate', {
				api_id: api._id,
				api_name: api.name,
				limit,
				maytapi: api.maytapi,
			}).then(res => {
				if (res.success) {
					this.setState({ freeButtonLoad: false });
					this.loadPricing();
				}
			});
		} else {
			this.setState({ openModal: true });
		}
	};
	freeSubsTrial = (api, limit) => async ({ req, res }) => {
		if (!!this.props.session.user) {
			this.setState({ freeButtonLoad: true });
			rest('/rest/subscription/createTrial', {
				api_id: api._id,
				api_name: api.name,
				limit,
				maytapi: api.maytapi,
			}).then(res => {
				if (res.success) {
					this.setState({ freeButtonLoad: false });
					this.loadPricing();
				}
			});
		} else {
			this.setState({ openModal: true });
		}
	};
	cancelSub = (api_id, package_name) => async ({ req, res }) => {
		this.setState({ cancelModal: false });
		rest('/rest/subscription/cancelSubscription', {
			api_id,
			package_name,
		}).then(res => {
			if (res.success) {
				//this.setState({ freeButtonLoad: false });
				//window.alert('Deleted.');
				this.loadPricing();
			}
		});
	};
	test = (quantity, plan, api_id, api_name, packageName, limit, url) => async ({ req, res }) => {
		rest('/rest/subscription/checkSubscription', {
			api_id,
			api_name,
			packageName,
			limit,
		})
			.then(resp => {
				if (resp.success) {
					this.setState({ messageOnScreen: 'Process is successful!', messageColor: 'green' });
					this.loadPricing();
				} else {
					this.setState({ messageOnScreen: 'Process cannot be applied!', messageColor: 'red' });
				}
			})
			.catch(err => {
				console.error(err);
			});
	};
	update = (api_id, plan_id, package_name, limit, api_name) => async ({ req, res }) => {
		if (plan_id !== 'free') {
			rest('/rest/subscription/updateSubscription', {
				api_id,
				plan_id,
				api_name,
				package_name,
				limit,
			}).then(resp => {
				if (resp.success) {
					this.setState({ messageOnScreen: 'Process is successful!', messageColor: 'green', upModal: false });
					this.loadPricing();
				} else {
					this.setState({ messageOnScreen: 'Process cannot be applied!', messageColor: 'red' });
				}
			});
		} else {
			rest('/rest/subscription/cancelSubscription', {
				api_id,
				package_name: this.state.subList[0].package_name,
			}).then(res => {
				if (res.success) {
					rest('/rest/subscription/freeCreate', {
						api_id: api_id,
						package_name: package_name,
						api_name,
						limit,
					}).then(resp => {
						if (resp.success) {
							this.setState({ freeButtonLoad: false, upModal: false });
							this.loadPricing();
						}
					});
				}
			});
		}
	};
	checkoutHandler = (quantity, plan, api_id, api_name, packageName, limit, url) => async () => {
		if (this.props.session.user) {
			window.Paddle.Checkout.open({
				email: this.props.session.user.email,
				product: plan,
				allowQuantity: false,
				quantity: quantity,
				passthrough: {
					api_id,
					api_name,
					uid: this.props.session.user.id,
					limit,
					packageName,
					url,
				},
				successCallback: data => {
					rest('/rest/subscription/checkSubscription', {
						checkout_id: data.checkout.id,
						plan_id: data.product.id,
						user_id: data.user.id,
						api_id,
						quantity: data.product.quantity,
						email: data.user.email,
						extra: data,
						api_name,
						packageName,
						limit,
					})
						.then(resp => {
							if (resp.success) {
								location.reload();
								this.setState({ messageOnScreen: 'Process is successful!', messageColor: 'green' });
							} else {
								this.setState({ messageOnScreen: 'Process cannot be applied!', messageColor: 'red' });
							}
						})
						.catch(err => {
							console.error(err);
						});
				},
				closeCallback: data => {
					rest('/rest/subscription/closeCheckout', {
						api_id,
						package_name: packageName,
						data,
					}).then(res => {
						console.log('Checkout closed', api_id, packageName, data);
						this.setState({ messageOnScreen: 'Your process has been cancelled, see you again soon!', messageColor: 'red' });
					});
				},
			});
		} else {
			this.setState({ openModal: true });
		}
	};
	closeModal = () => this.setState({ openModal: false, cancelModal: false, upModal: false });
	cancelSubModal = (api_id, api_title) => () => {
		this.setState({ close_api_id: api_id, close_api_title: api_title, cancelModal: true });
	};
	updateSubModal = (api_id, plan_id, package_name, limit, api_name) => () => {
		this.setState({ up_api_id: api_id, up_plan_id: plan_id, up_package_name: package_name, up_limit: limit, up_api_name: api_name, upModal: true });
	};
	async loadPricing() {
		if (!this.state.loading) this.setState({ loading: true });
		let update = { loading: false };
		if (this.props.session.user) {
			let list = await rest('/rest/subscription/isSubs', { api_id: this.props.api._id });
			update.isSubs = !!list.result.length || '';
			update.subList = list.result || '';
		}
		let packages = await rest('/rest/subscription/packages', { api_id: this.props.api._id });
		update.packages = packages.result[0];
		this.setState(update);
	}

	render() {
		if (this.state.loading) {
			return (
				<div className="contact">
					<Container>
						<Loader active inline="centered" content="Loading..." />
					</Container>
				</div>
			);
		}

		const { api, t } = this.props;
		const pricePackage = [
			{
				title: 'Enterprise',
				price: 'Contact Us',
				starts: false,
				packageId: 'contactUs',
				int: false,
				lines: [{ text: 'Unlimited request / month' }],
			},
		];
		let apiPackage = this.state.packages ? this.state.packages.package : pricePackage;
		let current = this.state.subList && this.state.subList[0] && this.state.subList[0];
		//let currentPackage = current && current.package_name;
		let current_index = current ? _.findIndex(apiPackage, { title: current.package_name }) : -1;
		let has_enterprise = current && current.package_name === 'Enterprise';
		//let currentPackageOrder = current && current.order;
		let expired = current && current.status === 'expired';
		let whatsappApi = this.state.packages && this.state.packages.whatsapp;

		if (whatsappApi) {
			return (
				<div>
					<Text
						render={parser => (
							<Head>
								<title key="title">CollectAPI - {parser(api.page_title || api.name)}</title>
								<meta name="description" key="description" content={parser(api.description)} />
							</Head>
						)}
					/>
					<Grid centered stackable>
						{_.map(apiPackage, (it, i) => {
							let isActive = current_index === i;
							let isUpgrade = current_index < i;
							let isEnterprice = it.packageId === 'contactUs';
							let wide = it.wide ? 5 : 4;
							const getText = () => {
								if (!current) return 'Subscribe';
								if (isActive) return 'Unsubscribe';
								if (isUpgrade) return 'Upgrade';
								else return 'Downgrade';
							};
							return (
								<GridColumn key={i} width={5} style={{ margin: '5px 0 ' }}>
									<Segment raised textAlign="left">
										<Header as="h1">{it.title}</Header>
										<Divider />
										{it.price && (
											<div style={{ margin: 0, minHeight: '61px' }}>
												<div style={{ fontSize: 16, color: '#333', visibility: it.starts ? 'visible' : 'hidden' }}>Starts from</div>
												<span style={{ fontSize: '24px', lineHeight: '24px' }}>
													{it.int ? '$' + it.price : it.price}
													{it.int ? <span style={{ fontSize: 16, color: '#A9A9A9' }}>{it.year ? t('perYear') : t('perMonth')}</span> : ''}
												</span>
											</div>
										)}
										<Divider />
										<List divided relaxed verticalAlign="middle">
											{_.map(it.lines, ({ text, description = '', icon = 'right triangle' }, i) => (
												<List.Item key={i}>
													<List.Content style={{ display: 'inline-block' }}>
														<List.Header>{text}</List.Header>
														<List.Description>{'' + description}</List.Description>
													</List.Content>
												</List.Item>
											))}
										</List>
										<a href="https://yapaytech.com/products/whatsapp-business-api/registration" target="_blank">
											<Button as="div" fluid color="blue">
												Contact Us
											</Button>
										</a>
									</Segment>
								</GridColumn>
							);
						})}
						<Grid.Row>
							<div style={{ textAlign: 'center', marginTop: '30px', marginBottom: '20px' }}>
								<p style={{ fontSize: '18px', color: '#000', fontWeight: 'bold', margin: 0 }}>
									{t('discountOnYearly')}{' '}
									<a href="mailto:info@collectapi.com" style={{ color: '#000', fontWeight: 'bold' }}>
										info@collectapi.com
									</a>
								</p>
							</div>
						</Grid.Row>
					</Grid>
				</div>
			);
		} else {
			return (
				<div>
					<Text
						render={parser => (
							<Head>
								<title key="title">CollectAPI - {parser(api.page_title || api.name)}</title>
								<meta name="description" key="description" content={parser(api.description)} />
							</Head>
						)}
					/>
					<Grid centered stackable>
						{_.map(apiPackage, (it, i) => {
							let isActive = current_index === i && current.status === 'active';
							let isUpgrade = current_index < i;
							let wide = it.wide ? 5 : 4;
							let isEnterprice = it.packageId === 'contactUs';
							const getText = () => {
								if (!current) return 'Subscribe';
								if (current && current.status === 'expired') return 'Subscribe';
								if (isActive) return 'Unsubscribe';
								if (isUpgrade) return 'Upgrade';
								else return 'Downgrade';
							};
							return (
								<GridColumn key={i} width={wide} style={{ margin: '20px 0 ' }}>
									<Segment raised textAlign="left">
										<Header as="h1">{it.title}</Header>
										<Divider />
										{it.price && (
											<div style={{ margin: 0, minHeight: '61px' }}>
												<div style={{ fontSize: 16, color: '#333', visibility: it.starts ? 'visible' : 'hidden' }}>Starts from</div>
												<span style={{ fontSize: '24px', lineHeight: '24px' }}>
													{it.int ? '$' + it.price : it.price}
													{it.int ? <span style={{ fontSize: 16, color: '#A9A9A9' }}>{t('perMonth')}</span> : ''}
												</span>
											</div>
										)}
										<Divider />
										<List divided relaxed verticalAlign="middle">
											{_.map(it.lines, ({ text, description = '', icon = 'right triangle' }, i) => (
												<List.Item key={i}>
													<List.Content style={{ display: 'inline-block' }}>
														<List.Header>{text}</List.Header>
														<List.Description>{'' + description}</List.Description>
													</List.Content>
												</List.Item>
											))}
										</List>
										{isEnterprice ? (
											<Link href="/contact">
												<Button fluid color="blue">
													Contact Us
												</Button>
											</Link>
										) : has_enterprise ? (
											<Button color="teal" fluid disabled>
												Downgrade
											</Button>
										) : it.packageId === 'free' ? (
											it.title === 'Free' ? (
												<Button
													disabled={expired}
													fluid
													loading={this.state.freeButtonLoad}
													color={isActive ? 'red' : 'teal'}
													onClick={
														isActive ? this.cancelSubModal(api._id, it.title) : !current ? this.freeSubs(api, it.limit) : this.updateSubModal(api._id, it.packageId, it.title, it.limit, api.name)
													}
												>
													{getText()}
												</Button>
											) : (
												<Button
													disabled={expired}
													fluid
													loading={this.state.freeButtonLoad}
													color={isActive ? 'red' : 'teal'}
													onClick={
														isActive
															? this.cancelSubModal(api._id, it.title)
															: !current
															? it.title === 'Free'
																? this.freeSubs(api, it.limit)
																: this.freeSubsTrial(api, it.limit)
															: this.updateSubModal(api._id, it.packageId, it.title, it.limit, api.name)
													}
												>
													{expired ? 'Expired' : getText()}
												</Button>
											)
										) : (
											<Button
												fluid
												color={isActive ? 'red' : 'teal'}
												onClick={
													isActive
														? this.cancelSubModal(api._id, it.title)
														: !current || this.state.subList[0].package_name === 'Free' || this.state.subList[0].package_name === 'Free Trial'
														? this.checkoutHandler(1, it.packageId, api._id, api.name, it.title, it.limit)
														: this.updateSubModal(api._id, it.packageId, it.title, it.limit, api.name)
												}
											>
												{getText()}
											</Button>
										)}
									</Segment>
								</GridColumn>
							);
						})}
						<Grid.Row>
							<div style={{ textAlign: 'center', marginTop: '30px', marginBottom: '20px' }}>
								<p style={{ fontSize: '18px', color: '#000', fontWeight: 'bold', margin: 0 }}>
									{t('discountOnYearly')}{' '}
									<a href="mailto:info@collectapi.com" style={{ color: '#000', fontWeight: 'bold' }}>
										info@collectapi.com
									</a>
								</p>
							</div>
						</Grid.Row>
						{/* Login Modal  */}
						<Modal open={this.state.openModal} onClose={this.closeModal}>
							<Modal.Header>
								<Icon name="user" />
								{t('userNotFound')}
							</Modal.Header>
							<Modal.Content>
								<Modal.Description>
									<p>{t('userNotFoundText')}</p>
								</Modal.Description>
							</Modal.Content>
							<Modal.Actions>
								<Button color="red" inverted onClick={this.closeModal}>
									<Icon name="remove" /> {t('close')}
								</Button>
								<Link href="/auth">
									<Button color="green" inverted>
										<Icon name="checkmark" /> {t('login')}
									</Button>
								</Link>
							</Modal.Actions>
						</Modal>
						{/*Cancel Subs*/}
						<Modal open={this.state.cancelModal} onClose={this.closeModal}>
							<Modal.Header>
								<Icon name="user" />
								{t('unsubscribe')}
							</Modal.Header>
							<Modal.Content>
								<Modal.Description>
									<p>{t('unsubscribeText')}</p>
								</Modal.Description>
							</Modal.Content>
							<Modal.Actions>
								<Button color="red" inverted onClick={this.closeModal}>
									<Icon name="remove" /> {t('no')}
								</Button>
								<Button color="green" inverted onClick={this.cancelSub(this.state.close_api_id, this.state.close_api_title)}>
									<Icon name="checkmark" /> {t('yes')}
								</Button>
							</Modal.Actions>
						</Modal>
						{/* Change Modal */}
						<Modal open={this.state.upModal} onClose={this.closeModal}>
							<Modal.Header>
								<Icon name="user" />
								{t('changeSub')}
							</Modal.Header>
							<Modal.Content>
								<Modal.Description>
									<p>{t('changeSubText')}</p>
								</Modal.Description>
							</Modal.Content>
							<Modal.Actions>
								<Button color="red" inverted onClick={this.closeModal}>
									<Icon name="remove" /> {t('no')}
								</Button>
								<Button color="green" inverted onClick={this.update(this.state.up_api_id, this.state.up_plan_id, this.state.up_package_name, this.state.up_limit, this.state.up_api_name)}>
									<Icon name="checkmark" /> {t('yes')}
								</Button>
							</Modal.Actions>
						</Modal>
					</Grid>
				</div>
			);
		}
	}
}
class DocsTab extends React.Component {
	render() {
		const { api, t, i18n } = this.props;

		return (
			<React.Fragment>
				<Text
					render={parser => (
						<Head>
							<title key="title">CollectAPI - {parser(api.page_title || api.name)}</title>
							<meta name="description" key="description" content={parser(api.description)} />
						</Head>
					)}
				/>
				{i18n.language === 'tr' ? (
					<p>
						API çağrıları ve daha fazlası hakkında bilgi almak için{' '}
						<a href="https://docs.collectapi.com/docs/general" target="_blank">
							dokümanlar{' '}
						</a>
						sayfasına bakabilirsiniz.
					</p>
				) : (
					<p>
						For more information on API calls and more, see the{' '}
						<a href="https://docs.collectapi.com/docs/general" target="_blank">
							documentation{' '}
						</a>{' '}
						page.
					</p>
				)}
			</React.Fragment>
		);
	}
}

class ApiInfoTab extends React.Component {
	render() {
		const { api, t, i18n } = this.props;

		return (
			<React.Fragment>
				<Text
					render={parser => (
						<Head>
							<title key="title">CollectAPI - {parser(api.page_title || api.name)}</title>
							<meta name="description" key="description" content={parser(api.description)} />
						</Head>
					)}
				/>
				<div style={{ textAlign: 'left', padding: '10px' }}>{ReactHtmlParser(api.api_long_description[i18n.language])}</div>
			</React.Fragment>
		);
	}
}
class Detail extends React.Component {
	state = {
		loading: true,
	};
	static async getInitialProps({ req, query }) {
		let { group } = query;
		const [data, api] = await Promise.all([ssrFetch(req, GET_END_POINTS_URL + group).then(res => res.json()), ssrFetch(req, GET_APIS_URL + group).then(res => res.json())]);
		return { endpoints: data.result, api: api && api.result, namespacesRequired: ['common'], mainContainer: { fluid: true }, query, endpoint: query.endpoint };
	}
	componentDidMount() {
		this.setupPaddleMessageListener();
		this.loadData();
	}

	setupPaddleMessageListener() {
		// Global event listener ekle
		window.addEventListener('message', this.handlePaddleMessage);
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handlePaddleMessage);
	}

	handlePaddleMessage = event => {
		// Paddle'dan gelen mesajları kontrol et
		if (event && event.data && event.data.callback_data && event.data.callback_data.error) {
			//console.log('Paddle iframe event:', event.data);

			// Hata mesajlarını kontrol et

			// Hata yakalandı
			const errorMessage = event.data.callback_data.error;
			console.error('Paddle error:', event.data.callback_data);
			// Hatayı loglayın
			rest('/rest/subscription/paddleDeclined', {
				api_id: this.props.api._id,
				data: event.data.callback_data,
			});
		}
	};

	async loadData() {
		let update = { loading: false };
		if (!this.props.api) {
			// 404 sayfasına yönlendir
			window.location.href = '/'; // or use your routing method
			return;
		} else {
			if (this.props.session.user) {
				let list = await rest('/rest/subscription/isSubs', { api_id: this.props.api._id });
				update.isSubs = !!list.result.length || false;
				update.subList = list.result || '';
			}
			let packages = await rest('/rest/subscription/packages', { api_id: this.props.api._id });
			update.packages = packages.result[0];
			this.setState(update);
		}
	}

	/* 	handleTabChange = (e, data) => {
		try {
			let index = ['', '?tab=pricing'];
			let current = data.activeIndex || 0;
			let search = index[current];
			let url = location.pathname;
			if (search) url += search;
			Router.push('/api?group=' + this.props.query.group, url, { shallow: true });
		} catch (error) {
			console.error(error);
		}
	}; */

	render() {
		if (this.state.loading) return <Loader active inline="centered" content="Loading..." />;
		const { api, endpoints, t, session, endpoint, i18n, query } = this.props;
		const tabs = { pricing: 1 };
		let defaultIndex = tabs[query.tab] || 0;
		const scopes = (session && session.user && session.user.scopes) || '';
		//console.log(this.state.subList.result && this.state.subList.result[0].paddle_data.cancel_url);
		const panes = [
			{
				menuItem: t('description'),
				render: () => (
					<Tab.Pane as="div">
						<Description {...this.props} scopes={scopes} isSubs={this.state.isSubs} apiPackage={this.state.packages} />
					</Tab.Pane>
				),
			},
			{
				menuItem: t('pricing'),
				render: () => (
					<Tab.Pane as="div">
						<PricingTab api={api} session={session} t={t} />
					</Tab.Pane>
				),
			},
			{
				menuItem: t('docs'),
				render: () => (
					<Tab.Pane as="div">
						<DocsTab api={api} session={session} t={t} i18n={i18n} />
					</Tab.Pane>
				),
			},
		];
		if (api.api_long_description_status) {
			panes.push({
				menuItem: t('ApiInfo'),
				render: () => (
					<Tab.Pane as="div">
						<ApiInfoTab api={api} session={session} t={t} i18n={i18n} />
					</Tab.Pane>
				),
			});
		}

		return (
			<div style={{ width: '100%' }}>
				<div style={{ background: 'white', padding: '20px 0', borderBottom: '2px solid #b5cc18' }}>
					<Container textAlign="center">
						<Image src={api && api.image_url} rounded inline style={{ width: 80, height: 80, padding: 8 }} />
						<Header as="h2" style={{ marginTop: 0 }}>
							<Text text={api.name} />
						</Header>
						<Tab className="yt-nav-tab" defaultActiveIndex={defaultIndex} menu={{ secondary: true, pointing: true }} panes={panes} />
					</Container>
					<Container style={{ padding: '2rem 0' }}>
						<Divider horizontal>
							<h4>{t('end_points')}</h4>
						</Divider>
						{api.maytapi === true ? (
							<Suspense fallback={<Loader />}>
								<Swagger url={api.swagger_url} />
							</Suspense>
						) : (
							<Accordion items={_.orderBy(endpoints, ['order'], ['asc'])} api={api} activeIndex={api && api.activeIndex} user={session.user} endpoint={endpoint} />
						)}
						{/* <Accordion items={_.orderBy(endpoints, ['order'], ['asc'])} api={api} activeIndex={api && api.activeIndex} user={session.user} endpoint={endpoint} />
						 */}
						<Divider horizontal />
						<div style={{ display: 'flex', flexWrap: 'wrap' }}>
							{api.tags &&
								_.map(api.tags, (t, i) => {
									let urlName = _.kebabCase(t);
									return (
										<Link key={i} href={`/tags/${urlName}`} passHref>
											<a
												style={{
													margin: '0.25rem', // margin'i küçülttük
													backgroundColor: '#f5f5f5',
													color: '#333',
													border: 'none',
													borderRadius: '4px',
													padding: '0.25rem 0.5rem', // padding'i küçülttük
													fontSize: '0.75rem', // font boyutunu küçülttük
													fontWeight: 500,
													textDecoration: 'none',
													transition: 'all 0.2s ease-in-out',
													flex: '1 1 auto',
													textAlign: 'center',
												}}
												onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
												onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
												title={`${t}`}
											>
												{t}
											</a>
										</Link>
									);
								})}
						</div>
						<div className="suggest_list">
							{_.map(api.suggest_list, it => (
								<Segment>
									<Image src={it && it.image_url} rounded inline style={{ width: 80, height: 80, padding: 8 }} />
									<p className="sl-title">{it.name[i18n.language || 'tr']}</p>
									<p>{it.description[i18n.language || 'tr']}</p>
									<Button size="mini" primary as="a" href={`/api/${it.group_id}`}>
										{t('goto_api')}
									</Button>
								</Segment>
							))}
						</div>
					</Container>
				</div>
			</div>
		);
	}
}

export default withNamespaces()(Detail);
